import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

type SkeletonLineProps = {
    readonly width?: string;
};

export const SkeletonLine = ({ width = "100%" }: SkeletonLineProps) => (
    <Flex
        height="12px"
        width={width}
        borderRadius="4px"
        background={colorsPalettes.carbon[50]}
    />
);
